<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">Sanção</h4>
      </v-alert>
      <v-form :disabled="!userHasPermission()" v-model="valid" lazy-validation ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                label="Processo"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="sancao.numeroProcesso"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                label="Órgao"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="sancao.orgao"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                label="Sancionado"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="sancao.nome"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-radio-group v-model="tipoPessoa" row>
                <div style="margin-right:2%">Tipo Pessoa:</div>
                <v-radio label="Física" value="CPF"></v-radio>
                <v-radio label="Jurídica" value="CNPJ"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                label="CPF/CNPJ"
                v-mask="mask"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="sancao.cpfCnpj"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="2">
          <v-text-field
            type="date"
            label="Data Inicio"
            v-model="sancao.inicioSancao"
            required
            :rules="[(v) => !!v || 'Este campo é obrigatório!']"
          />
        </v-col>
        <v-col md="2">
          <v-text-field
            type="date"
            label="Data Fim"
            v-model="sancao.fimSancao"
          />
        </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="11">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="sancaoArea"
                label="Sanção"
                v-model="sancao.sancao"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="11">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="legalArea"
                label="Fundamento Legal"
                v-model="sancao.fundamentoLegal"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="11">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="obsArea"
                label="Observação"
                v-model="sancao.observacao"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn color="primary" small depressed @click="salvar()" :disabled="!userHasPermission()">
                Salvar
                </v-btn>
              <span></span>
              <v-btn
                style="margin-left: 2%"
                color="primary"
                small
                depressed
                to="/sancoes"
                >Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </app-layout>
</template>

<script>
import sancaoService from "@/service/SancaoService";
export default {
  data() {
    return {
      mask: '###.###.###-##',
      tipoPessoa: null,
      valid: false,
      sancao: {
        orgao: null,
        numeroProcesso: null,
        cpfCnpj: null,
        nome: null,
        fundamentoLegal: null,
        sancao: null
      },
    };
  },
  methods: {
    salvar(){
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        sancaoService
          .salvar(this.sancao)
          .then((result) => {
            (this.sancao = result), alert("Documento Salvo!"), this.sair();
          })
          .catch((err) => console.error(err.message));
      } else {
        alert("Informe os campos Obrigatórios!");
      }
    },
    sair(){
      this.$router.push("/sancoes");
    }
  },
  mounted() {
    if (this.$route.params.id != 0) {
      sancaoService
        .buscar(this.$route.params.id)
        .then( (res) => (this.sancao = res, this.tipoPessoa = res.tipoPessoa) );
    }
  },
  watch:{
    tipoPessoa: function(){
      if(this.tipoPessoa == "CPF"){
        this.mask = '###.###.###-##'
        this.sancao.tipoPessoa = 'CPF'
      }else{
        this.mask = '##.###.###/####-##'
        this.sancao.tipoPessoa = 'CNPJ'
      }
    }
  },
  
};
</script>

<style>
</style>